/*
 * Accessibility fix: keep off-screen aria-hidden elements out of the focus
 * order and accessibility tree.
 *
 * Some theme sliders/carousels mark inactive slides aria-hidden="true" while
 * leaving their links and buttons focusable. That fails the axe rule
 * "ARIA hidden element must not be focusable or contain focusable elements".
 *
 * We mirror the native `inert` attribute onto any aria-hidden="true" element
 * that contains focusable descendants, and remove it again when the element
 * becomes visible. inert removes the subtree from the tab order AND the
 * accessibility tree, which is exactly what the audit requires.
 */
(function () {
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,object,embed,[tabindex],[contenteditable="true"],audio[controls],video[controls]';

  function apply(el) {
    if (!el || el.nodeType !== 1 || !el.getAttribute) { return; }
    var hidden = el.getAttribute('aria-hidden') === 'true';
    if (hidden && (el.matches(FOCUSABLE) || el.querySelector(FOCUSABLE))) {
      if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); }
    } else if (!hidden && el.hasAttribute('inert')) {
      el.removeAttribute('inert');
    }
  }

  function scan(root) {
    if (!root) { return; }
    if (root.nodeType === 1 && root.getAttribute && root.getAttribute('aria-hidden') === 'true') {
      apply(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[aria-hidden="true"]').forEach(apply);
    }
  }

  function init() {
    scan(document);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          apply(m.target);
        } else if (m.type === 'childList' && m.addedNodes) {
          m.addedNodes.forEach(function (n) { scan(n); });
        }
      }
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
